// router.tsx
import React from 'react';
import { createHashRouter } from 'react-router-dom';
import MyApp from '../MyApp';
import Contacts from './Contacts';
import Login from './Login';
import WelcomePage from './Welcome';
import { ChatWrapper } from './Chat';
import NotFound from './NotFound';
import ProtectedRoute from './ProtectedRoute';
import Profile from './Profile';
import { Logout } from './Logout';
import { PersonalPictograms } from './PersonalPictograms';

/**
 * Function to get the active page from the URL hash.
 * @returns {string} The active page.
 */
export const getActivePage = (): string => {
  let hash = window.location.hash;
  let page = hash.split('/');
  if (page.length > 1)
    return page[1];
  return page[0];
}

// Define the routes for the application using createHashRouter
export const router = createHashRouter([
  {
    path: '/',
    element: <MyApp />,
    errorElement: <NotFound />,
    children: [
      {
        index: true, // ✅ rotta predefinita
        element: (
          <ProtectedRoute>
            <Contacts />
          </ProtectedRoute>
        ),
      },
      {
        path: 'welcomePage',
        element: <WelcomePage />,
      },
      {
        path: 'login',
        element: <Login />,
      },
      {
        path: 'contacts',
        element: (
          <ProtectedRoute>
            <Contacts />
          </ProtectedRoute>
        ),
      },
      {
        path: 'chat/:chatId',
        element: (
          <ProtectedRoute>
            <ChatWrapper />
          </ProtectedRoute>
        ),
      },
      {
        path: 'profile',
        element: (
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        ),
      },
      {
        path: 'personalPictograms',
        element: (
          <ProtectedRoute>
            <PersonalPictograms />
          </ProtectedRoute>
        ),
      },
      {
        path: 'logout',
        element: <Logout />,
      },
    ],
  },
]);